import {FormattedMessage} from 'react-intl';

import {ReactionsNotificationLevel} from 'features/notifications/constants/notification';

export type Props = {
    notificationLevel: ReactionsNotificationLevel;
    onNotificationLevelChanged: (level: ReactionsNotificationLevel) => void;
};

export const ReactionNotificationsSettings = ({
    notificationLevel,
    onNotificationLevelChanged,
}: Props) => {
    return (
        <fieldset>
            <legend className='form-legend'>
                <FormattedMessage
                    id='user.settings.notifications.desktop.reactions.title'
                    defaultMessage='Reaction notifications'
                />
            </legend>
            <div className='radio'>
                <label>
                    <input
                        type='radio'
                        name='reaction-notifications'
                        value={ReactionsNotificationLevel.DIRECT}
                        checked={notificationLevel === ReactionsNotificationLevel.DIRECT}
                        onChange={() => onNotificationLevelChanged(ReactionsNotificationLevel.DIRECT)}
                    />
                    <FormattedMessage
                        id='user.settings.notifications.desktop.reactions.direct'
                        defaultMessage='Direct messages'
                    />
                </label>
                <br />
            </div>
            <div className='radio'>
                <label>
                    <input
                        type='radio'
                        name='reaction-notifications'
                        value={ReactionsNotificationLevel.CONVERSATIONS}
                        checked={notificationLevel === ReactionsNotificationLevel.CONVERSATIONS}
                        onChange={() => onNotificationLevelChanged(ReactionsNotificationLevel.CONVERSATIONS)}
                    />
                    <FormattedMessage
                        id='user.settings.notifications.desktop.reactions.conversation'
                        defaultMessage='Direct messages and conversations'
                    />
                </label>
                <br />
            </div>
            <div className='radio'>
                <label>
                    <input
                        type='radio'
                        name='reaction-notifications'
                        value={ReactionsNotificationLevel.NONE}
                        checked={notificationLevel === ReactionsNotificationLevel.NONE}
                        onChange={() => onNotificationLevelChanged(ReactionsNotificationLevel.NONE)}
                    />
                    <FormattedMessage
                        id='user.settings.notifications.desktop.reactions.never'
                        defaultMessage='Never'
                    />
                </label>
                <br />
            </div>
            <div className='mt-5'>
                <FormattedMessage
                    id='user.settings.notifications.desktop.reactions.descr'
                    defaultMessage='We will send a notification when one of the users post reaction on your message.'
                />
            </div>
        </fieldset>
    );
};
